const devLocal = {
  endpoints: {
    API_URL: 'http://localhost:61570/api'
  },
  env: 'local',
  showDevTools: true
}

const remoteDev = {
  endpoints: {
    API_URL: 'http://172.16.4.161:6090/api'
  },
  env: 'remoteDev',
  showDevTools: true,
  apikey: 'AIzaSyBS2M009Ue6rv-AqlmV3E3u8pkgiij0dyo'
}

const remoteTest = {
  endpoints: {
    PORTAL_URL: 'https://apiportest-grupoomint.msappproxy.net/api',
    API_URL: 'https://turnerabacktest-grupoomint.msappproxy.net/api'
  },
  env: 'remoteTest',
  apikey: 'AIzaSyBS2M009Ue6rv-AqlmV3E3u8pkgiij0dyo',
  showDevTools: true
}

const remotePreProd = {
  endpoints: {
    //API_URL: 'http://172.16.5.41:8081/api'
  },
  env: 'remotePreProd',
  apikey: 'AIzaSyBS2M009Ue6rv-AqlmV3E3u8pkgiij0dyo',
  showDevTools: true
}

const remoteProd = {
  endpoints: {
    API_URL: 'https://turnera.miportalclinicas.com.ar:8444/api'
  },
  env: 'remoteProd',
  apikey: 'AIzaSyBS2M009Ue6rv-AqlmV3E3u8pkgiij0dyo',
  showDevTools: false
}

const firebaseDev = {
  vapidKey:
    'BJwhK8D_IMyWftqhg8UOGwyentyNABI4RHkjVI9hnVqFBcq8TPw8vgQoFV6lPYBGMMIUH2ajQLMu3EPArsMUHAs',
  web: {
    apiKey: 'AIzaSyBL9S7kO83OkyycxzxD_Y40SceNEjNrtqA',
    authDomain: 'omint-portal-clinicas-test.firebaseapp.com',
    projectId: 'omint-portal-clinicas-test',
    storageBucket: 'omint-portal-clinicas-test.firebasestorage.app',
    messagingSenderId: '269642821924',
    appId: '1:269642821924:web:235ddf0d118a7e056d43b1'
  }
}

const firebaseTest = {
  vapidKey:
    'BDwOswA7e1EwOfPFIuYBPFd7QRSQzajVoiE7a9rz05RP4WWnnizaDm0vUtOn6Cl3W3Wv_e-Bmu9vhonV-iDb3UY',
  web: {
    apiKey: 'AIzaSyDX2o8TqD5s9qwfkERgWQxKcWTg19Dr3fk',
    authDomain: 'omintprepagamobiledev.firebaseapp.com',
    databaseURL: 'https://omintprepagamobiledev.firebaseio.com',
    projectId: 'omintprepagamobiledev',
    storageBucket: 'omintprepagamobiledev.appspot.com',
    messagingSenderId: '655015374803',
    appId: '1:655015374803:web:54666f8beb48a431ccc926'
  }
}

const firebaseProd = {
  vapidKey:
    'BDwOswA7e1EwOfPFIuYBPFd7QRSQzajVoiE7a9rz05RP4WWnnizaDm0vUtOn6Cl3W3Wv_e-Bmu9vhonV-iDb3UY',
  web: {
    apiKey: 'AIzaSyDX2o8TqD5s9qwfkERgWQxKcWTg19Dr3fk',
    authDomain: 'omintprepagamobiledev.firebaseapp.com',
    databaseURL: 'https://omintprepagamobiledev.firebaseio.com',
    projectId: 'omintprepagamobiledev',
    storageBucket: 'omintprepagamobiledev.appspot.com',
    messagingSenderId: '655015374803',
    appId: '1:655015374803:web:54666f8beb48a431ccc926'
  }
}

const config =
  process.env.REACT_APP_STAGE === 'prod'
    ? remoteProd
    : process.env.REACT_APP_STAGE === 'preprod'
    ? remotePreProd
    : process.env.REACT_APP_STAGE === 'remotetest'
    ? remoteTest
    : process.env.REACT_APP_STAGE === 'remotedev'
    ? remoteDev
    : devLocal

const firebase =
  process.env.REACT_APP_STAGE === 'prod'
    ? firebaseProd
    : process.env.REACT_APP_STAGE === 'preprod'
    ? firebaseTest
    : process.env.REACT_APP_STAGE === 'remotetest'
    ? firebaseTest
    : process.env.REACT_APP_STAGE === 'remotedev'
    ? firebaseDev
    : firebaseDev

export default {
  ...config,
  firebase
}
